/* ============================================
   GALERIE SIGNA · Animations JS
   Poids : ~1.8 Ko (minifie)
   ============================================ */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* ---- 1. FADE-IN AU SCROLL ---- */

  function initReveal() {
    var targets = [
      'section',
      '.footer-block',
      '.product-item',
      '.product-card',
      '.it-card',
      '.bls-toggle-modern',
      '.product-detail__buy-buttons',
      '.hero-signa__media'
    ];

    var elements = document.querySelectorAll(targets.join(','));
    elements.forEach(function (el) {
      if (!el.hasAttribute('data-signa-reveal') && !el.closest('[data-signa-reveal]')) {
        el.setAttribute('data-signa-reveal', '');
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-signa-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---- 2. TITRE HERO REVEAL ---- */

  function initTitleReveal() {
    var title = document.querySelector('.hero-signa__title');
    if (!title) return;

    var html = title.innerHTML;
    var words = html.split(/(\s+|<br\s*\/?>)/);
    var newHtml = '';
    var wordIndex = 0;

    words.forEach(function (part) {
      if (part.match(/^\s+$/) || part.match(/<br\s*\/?>/)) {
        newHtml += part;
      } else if (part.trim().length > 0) {
        var delay = 0.3 + wordIndex * 0.15;
        newHtml += '<span class="signa-word-wrap"><span class="signa-word" style="transition-delay:' + delay + 's">' + part + '</span></span> ';
        wordIndex++;
      }
    });

    title.innerHTML = newHtml;

    var eyebrow = document.querySelector('.hero-signa__eyebrow');
    var lead = document.querySelector('.hero-signa__lead');
    var actions = document.querySelector('.hero-signa__actions');
    var totalDelay = (0.3 + wordIndex * 0.15) * 1000 + 200;

    setTimeout(function () {
      if (eyebrow) eyebrow.classList.add('is-visible');
      title.querySelectorAll('.signa-word').forEach(function (w) {
        w.classList.add('is-visible');
      });
      setTimeout(function () {
        if (lead) {
          lead.style.transitionDelay = '0.2s';
          lead.classList.add('is-visible');
        }
        if (actions) {
          actions.style.transitionDelay = '0.4s';
          actions.classList.add('is-visible');
        }
      }, 400);
    }, 200);
  }

  /* ---- 3. INCLINAISON 3D DES CARTES ---- */

  function initTilt() {
    var cards = document.querySelectorAll('.product-item__inner, .product-item__wrapper');
    if (!cards.length) return;

    cards.forEach(function (card) {
      function applyTilt(x, y) {
        var rect = card.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var ry = ((x - cx) / (rect.width / 2)) * 6;
        var rx = -((y - cy) / (rect.height / 2)) * 6;
        card.style.transform = 'perspective(600px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.02)';
      }

      function resetTilt() {
        card.style.transform = 'perspective(600px) rotateX(0) rotateY(0) scale(1)';
      }

      card.addEventListener('mousemove', function (e) {
        applyTilt(e.clientX, e.clientY);
      });
      card.addEventListener('mouseleave', resetTilt);

      card.addEventListener('touchmove', function (e) {
        var t = e.touches[0];
        applyTilt(t.clientX, t.clientY);
      }, { passive: true });
      card.addEventListener('touchend', resetTilt);
    });
  }

  /* ---- 4. PARALLAXE HERO ---- */

  function initParallax() {
    var media = document.querySelector('.hero-signa__media img');
    if (!media) return;

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var rect = media.parentElement.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom > 0 && rect.top < vh) {
          var progress = (rect.top + rect.height) / (vh + rect.height);
          var offset = (progress - 0.5) * 40;
          media.style.transform = 'scale(1.08) translateY(' + offset + 'px)';
        }
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (window.DeviceOrientationEvent && 'ontouchstart' in window) {
      window.addEventListener('deviceorientation', function (e) {
        if (e.gamma === null) return;
        var x = Math.max(-15, Math.min(15, e.gamma)) / 15 * 10;
        var y = Math.max(-15, Math.min(15, e.beta - 45)) / 15 * 10;
        media.style.transform = 'scale(1.08) translate(' + x + 'px, ' + y + 'px)';
      }, { passive: true });
    }
  }

  /* ---- INIT ---- */

  function init() {
    initReveal();
    initTitleReveal();
    initTilt();
    initParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();